module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YdbKCz/tc-custom/9780062484550.jpg?1718184629306",
      "alt": "This image is the cover for the book Unlikely Story of a Pig in the City"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unlikely Story of a Pig in the City\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A “heartwarming and satisfying” middle grade novel about a young city girl’s adventure as she searches for a forever home for a pig ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Josie Shilling’s too-big family lives in a too-small city house, and sometimes she feels invisible. But all that changes when her brother brings home a tiny piglet he rescued from a farm. Her name is Hamlet. And the moment Josie holds her, she feels an instant bond."), _c('br'), _c('br'), _vm._v("But there’s no room for Hamlet in the crowded Shilling household. And whoever heard of keeping a pig in the city? So it’s up to Josie to find her a forever home. Along the way, she’ll learn what it really means to grow bigger when you’ve always felt small.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jodi Kendall\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0